// ASSETS
import "../../assets/styles/conflictsList.css";
import { FaEdit, FaTag } from "react-icons/fa";

// SERVICES
import modalHandler from "../../services/modalHandler";

// COMPONENTS
import ConflictsForm from "./ConflictsForm";

export default function SingleConflict(props) {
    return (
        <>
            {props.isEdit ?
                // EDIT
                <tr className="table-row">
                    <td>{props.conflict.alias}</td>
                    <td>{props.conflict.product_name}</td>
                    <td>{props.conflict.sku}</td>
                    <td >
                        <div className="action-buttons">
                            <button className="resolveBtn"
                                onClick={() => [
                                    modalHandler(
                                        <ConflictsForm
                                            conflict={props.conflict}
                                            setShowModal={props.setShowModal}
                                            isEdit={true}
                                            setRefetchTrigger={props.setRefetchTrigger}
                                        />,
                                        props.setModalItem,
                                        true,
                                        props.setShowModal
                                    ),
                                ]}>
                                <FaEdit className="text-warning " />
                            </button>
                        </div>
                    </td>
                </tr> :

                // NEW / RESOLVE
                <tr className="table-row">
                    <td>{props.conflict.product_name}</td>
                    <td className="action-buttons">
                        <button className="resolveBtn"
                            onClick={() => [
                                modalHandler(
                                    <ConflictsForm
                                        conflict={props.conflict}
                                        setShowModal={props.setShowModal}
                                        isEdit={false}
                                        setRefetchTrigger={props.setRefetchTrigger}
                                    />,
                                    props.setModalItem,
                                    true,
                                    props.setShowModal
                                ),
                            ]}>
                            <FaTag className="text-success" />
                        </button>
                    </td>
                </tr>
            }
        </>

    );
}
